import { Box, Icon, IconButton } from '@project44/manifest-ds';

import { scopedT } from '../../../../../../utils/helpers/scopedT';
import { createMarkerReference } from '../../draw';

interface PingsToggleComponentProps {
  onClick: () => void;
  disabled: boolean;
}

const PingsToggleComponent = ({
  onClick,
  disabled,
}: PingsToggleComponentProps) => {
  const t = scopedT();

  return (
    <Box css={{ background: '$background-surface', borderRadius: '$small' }}>
      <IconButton
        className="mapbox-pings-ctrl"
        variant="secondary"
        isDisabled={disabled}
        onClick={() => !disabled && onClick()}
        title={t('map.pings.title')}
        size="small"
      >
        <Icon icon="sensors" />
      </IconButton>
    </Box>
  );
};

export default class PingsToggle {
  private _container: HTMLElement;

  private _clickHandler: () => void;
  private _disabled: boolean;

  constructor({ onClick, disabled }: PingsToggleComponentProps) {
    this._clickHandler = onClick;
    this._disabled = disabled;
  }

  onAdd() {
    this._container = createMarkerReference(
      <PingsToggleComponent
        disabled={this._disabled}
        onClick={this._clickHandler}
      />,
    );
    this._container.className = 'mapboxgl-ctrl';
    return this._container;
  }

  onRemove() {
    this._container.parentNode?.removeChild(this._container);
  }
}
